import React from 'react';
import { motion } from 'framer-motion';
import { SimpleDivider } from './Dividers';
const team = [{
  name: 'Theron Ashwick',
  role: 'Chief Executive',
  desc: 'Former entertainment syndication lead who saw the void in niche distribution.'
}, {
  name: 'Seraphine Kael',
  role: 'Head of Partnerships',
  desc: 'Ex-fantasy publishing veteran bridging the gap between creators and brands.'
}, {
  name: 'Aldric Wynn',
  role: 'Chief Technology',
  desc: 'Architect of the Oracle Dashboard and arcane recommendation engines.'
}, {
  name: 'Liora Duskwood',
  role: 'Creative Director',
  desc: 'Award-winning fantasy art director ensuring aesthetic immersion across the network.'
}];
export const Team = () => {
  return <section id="about" className="py-24 bg-burgundy-950 relative" data-id="element-189">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-190">
        <div className="flex flex-col md:flex-row gap-16 items-center mb-20" data-id="element-191">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="md:w-1/2" data-id="element-192">
            <h2 className="font-display text-4xl md:text-5xl text-gold-500 mb-6" data-id="element-193">
              The Inner Circle
            </h2>
            <p className="text-xl text-parchment-200 leading-relaxed mb-6" data-id="element-194">
              Mythicplay was forged by veterans of both the entertainment
              industry and the fantasy publishing realm. We saw a landscape
              where incredible creators were shouting into the void, while
              audiences starved for specific lore.
            </p>
            <p className="text-xl text-parchment-200 leading-relaxed" data-id="element-195">
              Our mission is to build the infrastructure that allows fantasy
              worlds to thrive, ensuring that every tale finds its rightful
              audience.
            </p>
          </motion.div>
          <div className="md:w-1/2 flex justify-center" data-id="element-196">
            <div className="w-64 h-64 rounded-full border-ornate flex items-center justify-center bg-burgundy-900/50 shadow-gold-glow" data-id="element-197">
              <span className="font-display text-8xl text-gold-600/30" data-id="element-198">M</span>
            </div>
          </div>
        </div>

        <SimpleDivider className="mb-16" data-id="element-199" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-200">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="text-center" data-id="element-201">
              <div className="w-32 h-32 mx-auto rounded-full border-2 border-gold-600/50 p-1 mb-6 relative group" data-id="element-202">
                <div className="w-full h-full rounded-full bg-burgundy-900 flex items-center justify-center overflow-hidden" data-id="element-203">
                  {/* Placeholder for avatar */}
                  <div className="w-full h-full bg-gradient-to-br from-burgundy-800 to-burgundy-950 flex items-center justify-center group-hover:scale-110 transition-transform duration-500" data-id="element-204">
                    <span className="font-display text-3xl text-gold-600/50" data-id="element-205">
                      {member.name.charAt(0)}
                    </span>
                  </div>
                </div>
                {/* Ornate dots around avatar */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-gold-500 rotate-45" data-id="element-206"></div>
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gold-500 rotate-45" data-id="element-207"></div>
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-gold-500 rotate-45" data-id="element-208"></div>
                <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-gold-500 rotate-45" data-id="element-209"></div>
              </div>
              <h3 className="font-heading text-xl font-bold text-parchment-100 mb-1" data-id="element-210">
                {member.name}
              </h3>
              <p className="text-gold-500 text-sm uppercase tracking-widest mb-3" data-id="element-211">
                {member.role}
              </p>
              <p className="text-parchment-300 text-sm leading-relaxed" data-id="element-212">
                {member.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};